import apiClient from './client'
import type { ActivityEvent } from '@/types'

export const activityApi = {
  getByAssistant: async (assistantId: string): Promise<ActivityEvent[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/activity-feed`)
    return data
  },
}
